import * as React from "react";

function SvgUndrawTransferMoneyRywa(props: any) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="1099"
      height="797.68034"
      viewBox="0 0 1099 797.68"
      {...props}
    >
      <circle cx={471} cy={373} r={373} fill="#f2f2f2" />
      <ellipse cx={148} cy={774} rx={148} ry={23.68} fill="#f2f2f2" />
      <ellipse cx={870} cy={736.969} rx={229} ry={36.64} fill="#f2f2f2" />
      <path
        d="M819.12 384.785s1.95 6.498-9.098 12.347-14.297 27.945-1.3 34.444 16.897 14.947 10.398 20.796-18.196 21.446-2.6 25.345 17.547 11.698 12.998 14.947 10.398-5.849 10.398-5.849 2.6 15.597 16.247 11.698 51.99-77.985 32.494-88.383-69.537-25.345-69.537-25.345z"
        fill="#2f2e41"
      />
      <path
        d="M842.675 447.537s6.741 23.594-5.056 25.28a46.052 46.052 0 00-20.223 8.426l21.908 28.65h40.448l25.28-25.28s-33.707-25.28-26.966-40.447-35.39 3.37-35.39 3.37z"
        fill="#ffb9b9"
      />
      <path
        d="M842.675 447.537s6.741 23.594-5.056 25.28a46.052 46.052 0 00-20.223 8.426l21.908 28.65h40.448l25.28-25.28s-33.707-25.28-26.966-40.447-35.39 3.37-35.39 3.37z"
        opacity={0.1}
      />
      <path
        fill="#ffb9b9"
        d="M852.787 740.779l38.762 13.482 26.964 1.685-1.685-23.594-55.615-16.448-8.426 24.875z"
      />
      <path
        d="M902.503 735.723s0 23.594 3.37 23.594 48.874-5.056 62.357 0 33.706-13.483 23.594-23.594-26.606-25.28-36.897-21.91-52.424 11.798-52.424 11.798zM778.634 713.814s-20.224 40.447-6.741 43.818 28.65-1.686 30.335-3.371 25.28-8.427 28.65-5.056 3.37-13.482 3.37-13.482z"
        fill="#575a89"
      />
      <path
        d="M795.487 658.199s-32.02 43.818-8.427 55.615 136.51 11.797 144.936 0 11.797-48.874 0-52.244-136.51-3.371-136.51-3.371z"
        fill="#2f2e41"
      />
      <path
        d="M795.487 658.199s-32.02 43.818-8.427 55.615 136.51 11.797 144.936 0 11.797-48.874 0-52.244-136.51-3.371-136.51-3.371z"
        opacity={0.2}
      />
      <circle cx={856.157} cy={420.572} r={38.762} fill="#ffb9b9" />
      <path
        d="M795.487 481.243l33.706-6.741s8.426 26.964 35.39 21.909 33.707-21.91 33.707-21.91 20.223 8.427 21.909 8.427 23.594 8.427 23.594 13.483-25.28 55.614-25.28 55.614l3.371 91.006-124.712-3.37 8.427-89.321z"
        fill="#3f51b5"
      />
      <path
        d="M776.949 525.06s-10.112 89.321-3.371 96.062 33.706 25.28 33.706 25.28v-20.224l-13.483-25.28 13.483-58.984zM951.377 522.533s-5.899 91.848-5.899 95.219-15.167 15.168-20.223 15.168-8.427-8.427-8.427-8.427l11.797-13.482-8.426-69.097z"
        fill="#ffb9b9"
      />
      <path
        d="M935.366 651.458s75.839-42.133 77.524 0-38.762 58.985-38.762 58.985-104.488 31.332-108.701 19.88-12.64-29.992-5.899-31.677 15.168-5.056 18.538-1.685 45.503-25.28 45.503-25.28z"
        fill="#2f2e41"
      />
      <path
        d="M970.758 646.402s-15.168 6.741-20.224 11.797-26.965 13.482-26.965 13.482"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={2}
        opacity={0.2}
      />
      <path
        d="M805.599 484.613l-10.112-3.37s-37.077 38.762-25.28 48.873 18.539 13.483 21.91 16.853 20.223 5.056 20.223 5.056zM928.625 493.04l15.168 3.37s11.797 25.28 15.168 28.65-5.056 1.686-10.112 8.427-10.112 18.538-20.224 18.538-23.594-16.853-23.594-16.853z"
        fill="#3f51b5"
      />
      <path
        d="M798.857 666.625s-64.04-45.503-85.95-11.797 94.377 79.21 111.23 85.95 32.02 13.483 32.02 13.483 15.168-37.077 15.168-43.818-11.797-6.741-15.168-6.741-18.538-3.37-21.908-8.426-35.392-28.65-35.392-28.65z"
        fill="#2f2e41"
      />
      <path
        d="M763.466 654.828s16.853 13.483 32.02 16.853 20.224 11.797 20.224 11.797"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={2}
        opacity={0.2}
      />
      <path
        d="M787.232 591.462l1.346 71.356a8.933 8.933 0 009.032 8.764l132.79-1.492a8.933 8.933 0 008.817-8.418l4.03-69.864a8.933 8.933 0 00-8.917-9.447H796.163a8.933 8.933 0 00-8.931 9.1z"
        fill="#575a89"
      />
      <path
        d="M858.228 371.88s2.16 7.2-10.079 13.679-15.838 30.957-1.44 38.156 18.719 16.559 11.52 23.038-20.159 23.758-2.88 28.077 19.438 12.96 14.398 16.559 11.52-6.48 11.52-6.48 2.879 17.279 17.998 12.96 30.203-82.84 13.35-103.064c-15.67-18.805-54.387-22.925-54.387-22.925z"
        fill="#2f2e41"
      />
      <path
        d="M853.63 364.47c.003-10.548 31.558-2.97 45.088 11.757 9.368 10.198 23.598 25.54 11.674 36.356s20.44 24.992 29.119 29.29 25.817 17.443 10.343 26.261-15.224 17.72-9.4 19.828-12.84-3.134-12.84-3.134 1.885 17.415-13.838 17.332-60.832-86.495-50.056-110.513c10.02-22.333-10.09-27.178-10.09-27.178z"
        fill="#2f2e41"
      />
      <path
        d="M860.465 362.158c-42.198-2.541-46.433 29.223-46.433 29.223.291 18.382 29.482 9.425 37.59 12.165 9.781-7.036 28.636-20.35 42.12-29.851a63.774 63.774 0 00-33.277-11.537z"
        fill="#2f2e41"
      />
      <path
        d="M848.442 564.849S810.59 387.449 573.67 258.76"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        fill="#3f3d56"
        d="M583.431 254.891l.474 1.945-9.583 2.324 3.019 9.389-1.906.611-3.675-11.436 11.671-2.833z"
      />
      <path
        d="M68.473 746.111c0 22.47-13.356 30.314-29.834 30.314q-.572 0-1.143-.012a48.69 48.69 0 01-2.267-.104c-14.87-1.053-26.423-9.301-26.423-30.198 0-21.625 27.634-48.912 29.71-50.931l.003-.004.12-.116s29.834 28.583 29.834 51.051z"
        fill="#3f51b5"
      />
      <path
        d="M37.552 772.988l10.912-15.247-10.939 16.921-.029 1.75a48.69 48.69 0 01-2.267-.103l1.177-22.48-.01-.174.02-.033.111-2.123-10.966-16.963 11 15.37.026.452.89-16.985-9.39-17.528 9.504 14.547.925-35.212.003-.12v.116l-.154 27.767 9.347-11.008-9.385 13.4-.247 15.207 8.726-14.594-8.763 16.832-.138 8.454 12.67-20.313-12.717 23.263z"
        fill="#3f3d56"
      />
      <path
        d="M210.773 740.29l6.382-4.74s4.224 23.596-.49 27.131-22.39 9.428-22.39 16.499-40.068 16.498-41.246 5.892 3.535-16.498 3.535-16.498 18.855-18.856 21.212-22.391 8.25-10.606 8.25-10.606z"
        fill="#2f2e41"
      />
      <path
        d="M116.496 446.854s.177 1.037.483 2.934c.283 1.685.672 4.066 1.144 7 4.95 30.204 19.385 119.119 18.407 122.053-1.178 3.536-9.427 16.499 0 20.034.908.342 1.886 1.45 2.935 3.194a68.494 68.494 0 014.984 11.76c5.622 16.31 11.632 42.414 15.108 60.491 1.52 7.943 2.558 14.33 2.864 17.677a9.612 9.612 0 01.035 2.334c-1.178 4.713 7.071 21.212 10.606 25.926s9.428 9.427 8.25 14.141 29.461 17.677 32.997 9.428 3.535-12.963 4.713-15.32 2.357-18.856-3.535-21.212-2.357-43.603-8.25-51.853c-1.967-2.746-4.972-12.044-8.119-23.227a764.882 764.882 0 01-3.712-13.73c-4.973-19.173-9.38-38.464-9.38-38.464l1.178-137.88-64.815-8.25-1.662 3.666-3.311 7.27zM112.961 673.118s-9.428-9.428-14.142 0-9.427 45.96-17.676 54.21-18.856 49.495-7.071 51.852 24.747-3.536 25.926-10.606 25.926-43.604 25.926-47.139-16.498-16.498-16.498-16.498z"
        fill="#2f2e41"
      />
      <path
        d="M257.912 382.038s-15.32 137.88-18.856 150.843-22.39 62.459-28.283 70.708-43.603 75.421-48.317 78.957-14.141 12.963-14.141 12.963-17.677 17.677-20.034 21.212-22.39-7.07-23.57-14.141 1.18-18.856 2.358-23.57-2.357-11.784 1.178-15.32 21.212-21.212 21.212-29.461 30.64-56.566 42.425-67.172 9.428-28.283 9.428-28.283v-71.886l-64.816-20.034s3.536-56.566 11.785-56.566 116.668-18.856 129.63-8.25z"
        fill="#2f2e41"
      />
      <circle cx={162.456} cy={146.346} r={38.889} fill="#9f616a" />
      <path
        d="M175.42 176.986s4.713 17.677 10.606 22.39-15.32 24.749-15.32 24.749l-40.068 2.356-7.07-22.39s12.962-25.926 9.427-42.425 42.424 15.32 42.424 15.32z"
        fill="#9f616a"
      />
      <path
        d="M191.918 197.02s-10.606 1.178-12.963 4.714-18.856 14.141-31.819 11.784-21.212-5.892-23.569-4.713-7.07 25.926-7.07 25.926l12.962 37.71-2.356 103.705-3.536 28.283s-7.07-9.428 21.212-3.535 64.816-4.714 76.6-5.893 31.819-4.713 32.997-11.784-3.535-32.997-3.535-32.997l-18.855-78.957-11.785-42.425z"
        fill="#3f51b5"
      />
      <path
        d="M180.77 191.701s9.97-5.287 13.505-.573 48.317 11.784 48.317 15.32 9.427 98.99 7.07 107.24 4.714 17.677 4.714 17.677l8.25 35.353s22.39 67.173 12.963 69.53-17.677 0-21.213 0-2.357-44.782-11.784-56.567-22.391-41.246-24.748-47.138-31.818-87.206-30.64-96.634-6.433-44.208-6.433-44.208zM131.816 197.02s-9.427 0-10.606 2.357-12.963 17.677-17.677 21.212-21.212 18.856-21.212 22.39 34.175 29.462 34.175 29.462 14.142 69.53 7.071 93.099-17.677 80.135-12.963 83.67 15.32 4.714 15.32 0 7.07-55.387 12.963-65.993 23.57-77.779 16.499-96.634-23.57-89.563-23.57-89.563z"
        fill="#d0cde1"
      />
      <path
        d="M287.373 313.688s1.179 36.532-11.784 55.387-21.213 40.068-21.213 40.068-21.212-5.892-24.747-12.963-25.927-1.179-25.927-3.536 27.105-14.141 29.462-16.498 10.606-2.357 15.32-7.07 5.892-15.32 5.892-15.32l4.714-30.64z"
        fill="#9f616a"
      />
      <path
        d="M189.241 122.368c2.992-.272 6.078-.571 8.722-1.997 5.924-3.195 7.495-12.294 2.985-17.29a22.344 22.344 0 00-4.143-3.332l-8.958-6.097c-3.962-2.697-8.017-5.438-12.638-6.709-4.18-1.15-8.594-1.032-12.92-.763-8.399.522-16.85 1.6-24.749 4.5s-15.268 7.751-20.052 14.674c-7.585 10.974-7.689 25.775-3.512 38.444s12.113 23.701 19.932 34.51l4.056-19.795c.362-1.763.83-3.696 2.295-4.739 3.645-2.593 8.103 2.731 12.576 2.697 2.874-.022 5.287-2.386 6.376-5.046s1.161-5.605 1.413-8.468c.534-6.065 2.654-14.502 8.396-17.847 5.352-3.116 14.206-2.196 20.221-2.742z"
        fill="#2f2e41"
      />
      <path d="M187.06 447.805s-3.98 115.127-6.338 118.662 0-119.024 0-119.024z" opacity={0.1} />
      <path
        d="M233.164 206.448h9.428s40.067 54.209 35.354 57.744 0 12.963 0 12.963l9.427 17.677s11.785 10.606 8.25 12.963-8.25 11.785-8.25 11.785-23.569-3.535-30.64 10.606L241.45 310.89z"
        fill="#d0cde1"
      />
      <path fill="#2f2e41" d="M204.145 237.243l32.35-13.36 24.895 60.287-32.35 13.359z" />
      <ellipse
        cx={280.75}
        cy={304.458}
        rx={7}
        ry={6.431}
        transform="rotate(-22.438 126.536 406.18)"
        fill="#3f51b5"
      />
      <path
        d="M209.595 300.725s-84.85 70.707-98.99 48.316 15.32-41.246 15.32-41.246 25.925 1.179 55.387-17.677l29.461-12.963s26.896-38.399 36.062-23.777-15.645 40.07-37.24 47.347z"
        fill="#9f616a"
      />
      <path
        d="M95.284 238.266l-12.963 4.714v35.354l-4.714 7.07s1.179 14.142 4.714 17.677 10.606 2.357 8.25 10.607a44.667 44.667 0 00-1.18 16.498s21.213 27.105 22.392 23.57 17.676-47.14 20.033-47.14-23.569-68.35-23.569-68.35z"
        fill="#d0cde1"
      />
      <path
        d="M250.252 416.803s12.185-11.785 6.092-12.374-27.305-12.374-30.84-6.481 24.748 18.855 24.748 18.855z"
        fill="#2f2e41"
      />
      <ellipse cx={482} cy={183} rx={17} ry={9} fill="#57b894" />
      <path
        d="M547 213q-57.5-21.716-115 0v-47a199.038 199.038 0 01115 0z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        d="M531 203.28q-41.5-15.673-83 0V169.36a143.653 143.653 0 0183 0z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <ellipse
        cx={488}
        cy={179}
        rx={17}
        ry={9}
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <ellipse
        cx={543.2}
        cy={290.706}
        rx={17}
        ry={9}
        transform="rotate(-11.535 264.702 515.108)"
        fill="#57b894"
      />
      <path
        d="M562.386 255.941q-60.68-9.779-112.677 22.997l-9.398-46.05a199.038 199.038 0 01112.677-22.997z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        d="M544.766 249.617q-43.796-7.058-81.323 16.598l-6.784-33.236a143.653 143.653 0 0181.323-16.598z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <ellipse
        cx={548.279}
        cy={285.587}
        rx={17}
        ry={9}
        transform="rotate(-11.535 269.781 509.989)"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <ellipse
        cx={539.675}
        cy={346.645}
        rx={9}
        ry={17}
        transform="rotate(-86.019 487.003 348.133)"
        fill="#57b894"
      />
      <path
        d="M551.935 329.925q-55.853-25.656-114.722-7.983l3.262-46.887a199.038 199.038 0 01114.723 7.983z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        d="M536.649 319.118q-40.312-18.517-82.8-5.762l2.355-33.84a143.653 143.653 0 0182.8 5.762z"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <ellipse
        cx={545.938}
        cy={343.071}
        rx={9}
        ry={17}
        transform="rotate(-86.019 493.266 344.56)"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        d="M414.922 214.092s-73.496-10.055-125.982 20.703"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        fill="#3f3d56"
        d="M290.708 224.459l1.909.604-2.984 9.399 9.594 2.289-.467 1.947-11.683-2.791 3.631-11.448z"
      />
    </svg>
  );
}

export default SvgUndrawTransferMoneyRywa;
